import * as React from "react";
import InteractiveContext from "../contexts/InteractiveContext";
const IfInteractive = ({ children }) => /* @__PURE__ */ React.createElement(InteractiveContext.Consumer, null, (interactive) => interactive ? children : null);
export default IfInteractive;
